/*
 * How a payment row names and opens its session (goserver session_kind / session_label).
 * Group classes and workshops have their own details page; every other kind is a 1-on-1 page.
 */
const GROUP_KINDS = ['GROUP_CLASS', 'WORKSHOP'];
const KIND_NOUNS = { GROUP_CLASS: 'Group class', WORKSHOP: 'Workshop' };

const upper = (kind) => String(kind || '').toUpperCase();

export const is_group_kind = (kind) => GROUP_KINDS.indexOf(upper(kind)) !== -1;

// '' when there is no session to open (month-level rows).
export const session_href = (uuid, kind) => {
  if (!uuid) return '';
  const id = encodeURIComponent(uuid);
  return is_group_kind(kind)
    ? `/groupsessiondetails?session_uuid=${id}`
    : `/sessiondetails?id=${id}`;
};

// Who/what the session is, e.g. { noun: 'Group class', name: 'Morning Flow' }; an older server sends
// no label, so a 1-on-1 falls back to the row's student name.
export const session_who = (kind, label, student_name) => {
  const noun = KIND_NOUNS[upper(kind)] || 'Student';
  const name =
    String(label || '').trim() || (noun === 'Student' ? String(student_name || '').trim() : '');
  return { noun, name };
};
